import { paymentMethods } from '../data/pricingData';
import { contactInfo } from '../data/siteData';
import { FaCcPaypal, FaCreditCard, FaUniversity, FaMoneyCheckAlt, FaExchangeAlt, FaBitcoin, FaShieldAlt, FaLock, FaHeadset } from 'react-icons/fa';
import './PaymentOptions.css';

const PaymentOptions = () => {
  const iconMap = {
    'FaCcPaypal': <FaCcPaypal />,
    'FaCreditCard': <FaCreditCard />,
    'FaUniversity': <FaUniversity />,
    'FaMoneyCheckAlt': <FaMoneyCheckAlt />,
    'FaExchangeAlt': <FaExchangeAlt />,
    'FaBitcoin': <FaBitcoin />
  };

  return (
    <div className="payment-options-page">
      <div className="payment-hero">
        <div className="payment-hero-overlay"></div>
        <div className="container">
          <div className="payment-hero-content">
            <h1 className="payment-hero-title">Payment Options</h1>
            <p className="payment-hero-subtitle">Multiple secure payment methods for your convenience</p>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="section-intro">
            <h2>Choose Your Preferred Payment Method</h2>
            <p>
              We accept various payment methods to make it easy for students worldwide 
              to enroll in our courses. All transactions are secure and encrypted.
            </p>
          </div>

          <div className="payment-methods-grid">
            {paymentMethods.map(method => (
              <div key={method.id} className="payment-method-card">
                <div className="method-icon">
                  {iconMap[method.icon]}
                </div>
                <h3>{method.name}</h3>
                <p className="method-description">{method.description}</p>
                
                <div className="method-details">
                  <div className="detail-item">
                    <strong>Processing Time:</strong>
                    <span>{method.processingTime}</span>
                  </div>
                  <div className="detail-item">
                    <strong>Fees:</strong>
                    <span>{method.fees}</span>
                  </div>
                </div>

                <div className={`availability ${method.available ? 'available' : 'unavailable'}`}>
                  {method.available ? '✓ Available' : '✗ Coming Soon'}
                </div>
              </div>
            ))}
          </div>

          <div className="payment-info-section">
            <h2>Payment Information</h2>
            
            <div className="info-grid">
              <div className="info-card">
                <h3>💳 How to Pay</h3>
                <ol>
                  <li>Select your preferred course and plan</li>
                  <li>Choose your payment method during checkout</li>
                  <li>Complete the payment securely</li>
                  <li>Receive confirmation via email</li>
                  <li>Start your classes immediately</li>
                </ol>
              </div>

              <div className="info-card">
                <h3>🔒 Security & Privacy</h3>
                <p>
                  We use industry-standard SSL encryption to protect your payment information. 
                  We never store your complete card details on our servers. All payments are 
                  processed through secure, PCI-compliant payment gateways.
                </p>
              </div>

              <div className="info-card">
                <h3>📧 Bank Transfer Details</h3>
                <p>
                  For bank transfers, please contact our support team to receive our bank 
                  account details. Include your name and course information in the transfer 
                  reference. Allow 1-3 business days for payment processing.
                </p>
              </div>

              <div className="info-card">
                <h3>💰 Cryptocurrency Payment</h3>
                <p>
                  We accept Bitcoin (BTC), Ethereum (ETH), and USDT. Contact our support 
                  team for wallet addresses and current exchange rates. Payments are 
                  confirmed within 1 hour after network confirmation.
                </p>
              </div>
            </div>
          </div>

          <div className="security-badges">
            <h3>Why Our Payments Are Safe</h3>
            <div className="badges-grid">
              <div className="badge-item">
                <FaShieldAlt />
                <h4>SSL Encrypted</h4>
                <p>256-bit encryption</p>
              </div>
              <div className="badge-item">
                <FaLock />
                <h4>PCI Compliant</h4>
                <p>Industry standards</p>
              </div>
              <div className="badge-item">
                <FaHeadset />
                <h4>24/7 Support</h4>
                <p>Always here to help</p>
              </div>
            </div>
          </div>

          <div className="contact-payment">
            <h3>Need Help with Payment?</h3>
            <p>
              Our support team is available 24/7 to assist you with any payment-related questions.
            </p>
            <div className="contact-buttons">
              <a href="/contact-us" className="btn">Contact Support</a>
              <a href={`https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentOptions;
